import { css, keyframes } from "styled-components";

export const anchorBounce = keyframes`
	0%, 100% {
		transform: translateY(0);
	}
	50% {
		transform: translateY(-0.5em);
	}
`;

const verticalArrowMovement = keyframes`
	0%, 100% {
		transform: translateY(0);
	}
	50% {
		transform: translateY(0.8em);
	}
`;
const rightToLeftArrowMovement = keyframes`
	0%, 100% {
		transform: translateX(0);
	}
	50% {
		transform: translateX(-0.8em);
	}
`;

const rotatingShine = keyframes`
	0%, 100% {
		transform: translate(-50%, -50%) rotate(0deg);
	}
	50% {
		transform: translate(-50%, -50%) rotate(180deg);
	}
`;

export const rotatingShineAnimation = css`
	animation: ${rotatingShine} 6s ease-in-out infinite;

	@media (prefers-reduced-motion: reduce) {
		animation: none;
		transform: translate(-50%, -50%);
	}
`;

const arrowAnimation = (movement: ReturnType<typeof keyframes>) => css`
	animation: ${movement} 0.9s ease-in-out infinite;

	@media (prefers-reduced-motion: reduce) {
		animation: none;
	}
`;

export const verticalArrowAnimation = arrowAnimation(verticalArrowMovement);

export const rightToLeftArrowAnimation = arrowAnimation(
	rightToLeftArrowMovement
);
